import styled from 'styled-components';
import { Button } from '@mui/material';

import { breakpoint, COLORS } from '@themes';
import { ReactComponent as HeartFilledIcon } from '@assets/icons/heart_filled.svg';
import { ReactComponent as HeartOutlineIcon } from '@assets/icons/heart_outline.svg';

export const PageContainer = styled.div`
  background-color: ${(props) => props.theme.colors.black};
  min-height: 100vh;
`;

export const ContentWrapper = styled.div`
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const MainTitle = styled.h1`
  font-size: 48px;
  line-height: 56px;
  color: ${(props) => props.theme.colors.lightishGrey};
  font-family: 'Inter SemiBold';
  margin-top: 60px;
  margin-bottom: 40px;
  font-weight: 600;
`;

export const SectionTitle = styled.h2`
  color: ${(props) => props.theme.colors.lightishGrey};
  font-size: 20px;
  line-height: 28px;
  margin-top: 12px;
  margin-bottom: 24px;
  font-weight: 400;
  font-family: 'Inter Regular';
`;

export const SectionContainer = styled.div`
  margin-top: 50px;
  padding-bottom: 50px;
`;

export const MyWorkoutsWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.black};
  padding-bottom: 10px;
  margin-left: 16px;
  margin-right: 16px;

  ${breakpoint('sm')`
    margin-left: 32px;
    margin-right: 32px;
  `}

  ${breakpoint('lg')`
    margin-left: 80px;
    margin-right: 80px;
  `}
`;

export const SlicePlaceholderWrapper = styled.div`
  padding-top: 12px;
  width: 100%;
`;

export const NoResultsWrapper = styled.div`
  width: 100%;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  color: ${COLORS.lightGreyAE};
  font-family: Inter Light;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
  padding: 16px;
  white-space: pre-wrap;
  word-wrap: break-word;

  ${breakpoint('sm')`
    padding: 16px;
  `}
  ${breakpoint('md')`
    padding: 16px;
  `}
  ${breakpoint('lg')`
    padding: 32px;
  `}
  ${breakpoint('xl')`
    padding: 32px;
  `}
`;

export const StyledHeartIcon = styled(HeartFilledIcon)``;

export const StyledHeartOutlineIcon = styled(HeartOutlineIcon)`
  margin-left: 6px;
  margin-right: 6px;
`;

export const FavouriteContentContainer = styled.div`
  position: relative;
  height: 100%;
`;

export const FavoriteButton = styled(Button)`
  && {
    border-radius: 24px;
    height: 50px;
    position: absolute;
    top: 0px;
    right: 0px;

    &:hover {
      background-color: ${COLORS.whiteOpacity01};
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`;
